import React from "react";
import { AppStyledForm, StyledRow } from "./style.module";
import { FormTextField } from "./form-elements/FormTextField";
import { FormSelect } from "./form-elements/FormSelect";
import { FormRadio } from "./form-elements/FormRadio";
import { FormCheckbox } from "./form-elements/FormCheckbox";
import { FormDate } from "./form-elements/FormDate";
import { FormTransfer } from "./form-elements/FormTransfer";

const AppDynamicForm = ({ formField, handleSubmit, validated }) => {
  const renderInput = (inputType, key) => {
    try {
      switch (inputType.fieldtype) {
        case "textfield":
          return (
            <FormTextField
              key={key}
              elementkey={key}
              id={inputType.id}
              type={inputType.type}
              isDecimalAllowed={inputType.isDecimalAllowed}
              isSpecialCharsAllowed={inputType.isSpecialCharsAllowed}
              isDisabled={inputType.isDisabled}
              isMandatory={inputType.isMandatory}
              maxLength={inputType.maxLength}
              label={inputType.label}
              subtext={inputType.subtext}
              placeholder={inputType.placeholder}
              onTextChange={inputType.onChange}
              value={inputType.value}
              error={inputType.error}
              byPassRoleCheck={inputType.byPassRoleCheck}
              handleOnBlur={inputType?.onBlur}
            />
          );
        case "selectlist":
          return (
            <FormSelect
              key={key}
              elementkey={key}
              id={inputType.id}
              isMandatory={inputType.isMandatory}
              isDisabled={inputType.isDisabled}
              label={inputType.label}
              selectList={inputType.selectList}
              onSelect={inputType.onChange}
              value={inputType.value}
              error={inputType.error}
              isSearchable={inputType.isSearchable}
              isMulti={inputType.isMulti}
            />
          );
        case "radiolist":
          return (
            <FormRadio
              key={key}
              elementkey={key}
              id={inputType.id}
              label={inputType.label}
              selectList={inputType.selectList}
              onSelect={inputType.onChange}
              value={inputType.value}
              error={inputType.error}
              isMandatory={inputType.isMandatory}
              isDisabled={inputType.isDisabled}
            />
          );
        case "checkboxlist":
          return (
            <FormCheckbox
              key={key}
              elementkey={key}
              id={inputType.id}
              label={inputType.label}
              selectList={inputType.selectList}
              isDisabled={inputType.isDisabled}
              isMandatory={inputType.isMandatory}
              value={inputType.value}
              error={inputType.error}
              defaultValue={inputType.defaultValue}
              onSelect={inputType.onChange}
            />
          );
        case "date":
          return (
            <FormDate
              key={key}
              elementkey={key}
              id={inputType.id}
              label={inputType.label}
              isMandatory={inputType.isMandatory}
              error={inputType.error}
              onSelect={inputType.onChange}
            />
          );
        case "transfer":
          return (
            <FormTransfer
              key={key}
              id={inputType.id}
              elementkey={key}
              isMandatory={inputType.isMandatory}
              label={inputType.label}
              error={inputType.error}
              onSelect={inputType.onChange}
              userEmail={inputType.userEmail}
              formStateData={inputType.formStateData}
              setFormStateData={inputType.setFormStateData}
            />
          );
        default:
          return <></>;
      }
    } catch (err) {
      alert(err);
    }
  };

  const appFormContent = () => {
    try {
      let _formContent = "";
      if (formField && formField.length > 0) {
        _formContent = formField.map((row, rowindex) => {
          return (
            <StyledRow className="mb-3" key={"row-" + rowindex}>
              {row.map((item, index) => {
                return renderInput(item, "col-" + rowindex + "-" + index);
              })}
            </StyledRow>
          );
        });
      }
      return _formContent;
    } catch (err) {
      alert(err);
    }
  };
  return (
    <AppStyledForm noValidate validated={validated} onSubmit={handleSubmit}>
      {appFormContent()}
    </AppStyledForm>
  );
};
export { AppDynamicForm };
